import { observer } from 'mobx-react';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Heading, Selector, CardContent, Card, List, ListItem, Separator, scrollToElement, useTheme } from 'telia-front-react';
import TradeInConditionsBulletpoints from './TradeInConditionBulletpoints';
const questionHidden = ({ answeredQuestions, selectedDeviceId }, key) => answeredQuestions.has(key - 1) || (key === 0 && !!selectedDeviceId) ? '' : 'hidden';
const TradeInConditions = (props) => {
    const { tradeInStore, headingElement, translate } = props;
    const { media } = useTheme();
    const isInitialized = (key) => tradeInStore.answeredQuestions.has(key);
    const isMinWidthSm = useMediaQuery({ minWidth: media.width.sm.min });
    const resolveValue = (key, condition) => isInitialized(key) && (!tradeInStore.conditions.includes(condition) ? `question-yes-selector-${key}` : `question-no-selector-${key}`);
    return (!tradeInStore.isMaximumPriceFetching && (React.createElement(List, { bordered: false, type: "unstyled", fullWidth: true }, tradeInStore.initialConditions.map((condition, key) => (React.createElement(ListItem, { key: condition, className: questionHidden(tradeInStore, key) },
        React.createElement(Card, { isClosable: false, padding: "medium" },
            React.createElement(CardContent, null,
                React.createElement("p", { className: "text-center text-light text-bold", id: `card-counter-${key}` },
                    key + 1,
                    " / ",
                    tradeInStore.initialConditions.length),
                React.createElement(Heading, { element: headingElement, className: "h4 text-center text-bold" }, `${translate(`tradeIn.conditions.${tradeInStore.isAppleLaptop ? 'apple.' : ''}${condition}`)} `),
                tradeInStore.getConditionBulletPoints(condition).length > 0 && (React.createElement(TradeInConditionsBulletpoints, { conditionKey: key, condition: condition, translate: translate, tradeInStore: tradeInStore })),
                React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                React.createElement(Selector, { id: `question-selector-${key}`, align: "center", items: [
                        {
                            id: `question-yes-selector-${key}`,
                            name: `question-selector-${key}`,
                            label: `${translate('tradeIn.conditions.toggle.checked')}`,
                            value: `question-yes-selector-${key}`
                        },
                        {
                            id: `question-no-selector-${key}`,
                            name: `question-selector-${key}`,
                            label: `${translate('tradeIn.conditions.toggle.unchecked')}`,
                            value: `question-no-selector-${key}`
                        }
                    ], hideLabel: true, label: `${translate(`tradeIn.conditions.${tradeInStore.isAppleLaptop ? 'apple.' : ''}${condition}`)} `, itemWidth: ['xs-6', 'md-3'], value: resolveValue(key, condition), onChange: (value) => {
                        tradeInStore.setQuestionAnswer(key, value, condition);
                        setTimeout(() => {
                            if (!!document.getElementById(`card-counter-${key + 1}`)) {
                                scrollToElement(`card-counter-${key + 1}`, 500, isMinWidthSm ? 40 : 20);
                            }
                        }, 400);
                    } })))))))));
};
export default observer(TradeInConditions);
